import React, { useContext } from 'react';
import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { UserContext } from '../contexts/UserContext';

const Login = () => {
  const userCtx = useContext(UserContext);
  const { setUserId } = userCtx;
  const handleLogin = async () => {
    const auth = getAuth();
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then((result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        // ...
      })
      .then(() => {
        /// add user to db if not exists
        const userRef = doc(db, 'users', auth.currentUser.uid);
        const docSnap = getDoc(userRef);

        if (docSnap.exists) {
          console.log('Document data:', docSnap.data());
        } else {
          setDoc(doc(db, 'users', auth.currentUser.uid), {
            displayName: auth.currentUser.displayName,
            email: auth.currentUser.email,
          });
        }
        setUserId(auth.currentUser.uid);
      });
  };

  return (
    <div className="flex flex-col justify-center items-center h-screen">
      <button
        onClick={handleLogin}
        className="
        bg-blue-500
        hover:bg-blue-700
        text-white
        font-bold
        py-2
        px-4
        rounded
        
      "
      >
        Google Login
      </button>
    </div>
  );
};

export default Login;

/*    const userRef = addDoc(collection(db, 'users', user.id), {
          first: user.displayName,
          email: user.email,
        });
        console.log(userRef); */
